import * as React from 'react';
import { FC, useEffect } from 'react';

// TODO: expo-router - Fix useRumPageView hook
// import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { EventName, emitEvent } from 'utils/event-hub';

import { StoreLocator as StoreLocatorRefresh } from './new-ui';

/**
 *
 * StoreLocator purpose
 *
 */
export const StoreLocator: FC<React.PropsWithChildren<unknown>> = props => {
  // useRumPageView('store-locator', 'Store Locator'); // TODO: expo-router - Fix useRumPageView hook
  useEffect(() => {
    return () => {
      emitEvent(EventName.STORE_LOCATOR_UNMOUNT);
    };
  }, []);
  return <StoreLocatorRefresh {...props} />;
};

export default StoreLocator;
